import React from "react"
import { graphql } from "gatsby"
import { localize } from "../lib/helpers"

import Layout from "../components/layout"
import Seo from "../components/seo"
import FormCollabEn from "../components/Contact/formCollabEn"
import FormCollabEs from "../components/Contact/formCollabEs"

import Quote from "../components/Contact/quote"


const Collaborators = ({ data, pageContext, location }) => {
  const
    { _rawTitle, _rawQuote, _rawSectionTitle, _rawFields,
      _rawSection2Title, _rawPositions, _rawSection3Title,
    _rawResume, _rawResumeDescription, _rawWebpage, _rawCoverLetter } = localize(data.sanityCollaborators, [pageContext.language]);

  return (
    <Layout lang={pageContext.language}>
      <Seo title={_rawTitle} lang={pageContext.language} location={location} />
      <div id="collaborators">
        <Quote quote={_rawQuote} />

        {pageContext.language === "en" ? (
          <FormCollabEn title={_rawSectionTitle} fields={_rawFields}
          title2={_rawSection2Title} positions={_rawPositions} title3={_rawSection3Title}
          resume={_rawResume} description={_rawResumeDescription} website={_rawWebpage} cover={_rawCoverLetter} />
        ) : (
          <FormCollabEs title={_rawSectionTitle} fields={_rawFields}
          title2={_rawSection2Title} positions={_rawPositions} title3={_rawSection3Title} 
          resume={_rawResume} description={_rawResumeDescription} website={_rawWebpage} cover={_rawCoverLetter}/>
        )}
      </div>
    </Layout>
  )
}

export const query = graphql`
  query CollaboratorsPage {
    sanityCollaborators {
      _rawTitle
      _rawQuote
      _rawSectionTitle
      _rawFields
      _rawSection2Title
      _rawPositions
      _rawSection3Title,
      _rawResume,
      _rawResumeDescription,
      _rawWebpage,
      _rawCoverLetter
    }
  }
`

export default Collaborators
